import { setupHiddenLinkText } from "./hidden-link-text.ts";
import { setupLazyLoad } from "./lazy-load.ts";
import { setupStopReferrerHack } from "./stop-referrer-hack.ts";
import { setupToggles } from "./toggles.ts";
import { setupLists } from "./lists.ts";
import { setupSearchAutocomplete } from "./search-autocomplete.ts";

export function setup() {
  setupStopReferrerHack();
  setupToggles();
  setupLazyLoad();
  setupHiddenLinkText();
  setupLists();
  setupSearchAutocomplete();
}
